import * as moment from 'moment';
import _ from './lodash';
import { showAlertPopup } from './alertPopup';
import constants from '../config/constants';
class Utility {
    constructor() {
        this.moment = moment;
        this.Object = {
            IsEmpty(obj) {
                return _.isEmpty(obj);
            }
        };
        this.Date = {
            Format: 'DD/MM/YYYY',
            ZeroTime: 'T00:00:00.000Z'
        };
        this.Window = {
            GetViewPort() {
                return {
                    width: Math.max(document.documentElement.clientWidth, window.innerWidth || 0),
                    height: Math.max(document.documentElement.clientHeight, window.innerHeight || 0)
                };
            }
        };
        this.String = {
            IsNullOrEmpty(value) {
                return (!value || value.length === 0);
            },
            IsValidEmail(value) {
                let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                return re.test(value);
            },
            IsNullOrWhiteSpace(value) {
                if (value == null) {
                    return true;
                }
                for (let i = 0; i < value.length; i++) {
                    if (value[i] !== ' ') {
                        return false;
                    }
                }
                return true;
            },
            Format: (format, ...args) => {
                if (this.String.IsNullOrEmpty(format)) {
                    throw 'Format is null or empty.';
                }
                return format.replace(/{(\d+)}/g, function (match, num) {
                    return typeof args[num] !== 'undefined'
                        ? args[num]
                        : match;
                });
            },
            ReplaceAll: (value, oldChar, newChar) => {
                if (oldChar.length !== 1) {
                    throw 'Old char must be of length 1';
                }
                if (newChar.length !== 1) {
                    throw 'New char must be of length 1';
                }
                return value.replace(new RegExp(oldChar, 'g'), newChar);
            },
            Trim: (value, char) => {
                if (!char) {
                    return value.trim();
                }
                else {
                    if (value[0] === char) {
                        value = value.slice(1, value.length);
                    }
                    let end = value.length - 1;
                    if (value[end] === char) {
                        value = value.slice(0, end);
                    }
                    return value;
                }
            },
            TrimStart: (value, char) => {
                if (!char) {
                    return value.trim();
                }
                else {
                    if (value[0] === char) {
                        value = value.slice(1, value.length);
                    }
                    return value;
                }
            },
            TrimEnd: (value, char) => {
                if (!char) {
                    return value.trim();
                }
                else {
                    let end = value.length - 1;
                    if (value[end] === char) {
                        value = value.slice(0, end);
                    }
                    return value;
                }
            }
        };
        this.Number = {
            IsNumeric: (n) => {
                return !isNaN(parseFloat(n)) && isFinite(parseFloat(n));
            },
            IsInteger: (value) => {
                return typeof value === 'number' &&
                    isFinite(value) &&
                    Math.floor(value) === value;
            }
        };
        this.getPlatformString = () => {
            if (navigator.userAgent.match(/Android/i)) {
                return 'android';
            }
            if ((navigator.userAgent.match(/BlackBerry/i)) || (navigator.userAgent.match(/RIM Tablet OS/i)) || (navigator.userAgent.match(/BB10/i))) {
                return 'blackberry';
            }
            if (navigator.userAgent.match(/iPhone|iPad|iPod/i)) {
                return 'ios';
            }
            if (navigator.userAgent.match(/Windows Phone|IEMobile|WPDesktop/i)) {
                return 'wp';
            }
            let isFirefox = typeof InstallTrigger !== 'undefined';
            if (isFirefox) {
                return 'firefox';
            }
            let isSafari = Object.prototype.toString.call(window['HTMLElement']).indexOf('Constructor') > 0;
            if (isSafari) {
                return 'safari';
            }
            let isEdge = navigator.userAgent.indexOf(' Edge/') >= 0;
            if (isEdge) {
                return 'edge';
            }
            return 'unknown';
        };
    }
    alert(msg = "Something is wrong !!!", toastType) {
        if (toastType === constants.TOAST_TYPES.WARN) {
            showAlertPopup('warn', msg);
        }
        else if (toastType === constants.TOAST_TYPES.ERROR) {
            showAlertPopup('error', msg);
        }
        else if (toastType === constants.TOAST_TYPES.INFO || !toastType) {
            showAlertPopup('info', msg);
        }
    }
    mapDispatchToProps(dispatch) {
        return {
            Dispatch: dispatch
        };
    }
}
export const utility = new Utility();
